import { BusinessSector } from "@enums/businessSector.enum";
import { CrmLeadSource } from "@enums/crmLeadSource.enum";
import { CrmLeadStatus } from "@enums/crmLeadStatus.enum";
import { Model } from "@interfaces/model.interface";

export interface CrmLead extends Model {
	assignedUserId: number;
	clientId?: number;
	companyName: string;
	creditChecked: boolean;
	email: string;
	firstName: string;
	isActive: boolean;
	isSensitive: boolean;
	lastName: string;
	ndaFileLookupId?: string;
	ndaFileName?: string;
	ndaSigned: boolean;
	ndaValidFrom?: Date;
	ndaValidTo?: Date;
	notes: string;
	phone: string;
	potentialSpend?: number;
	recommendedCreditLimit?: number;
	salesEnquiryId: number;
	sector?: BusinessSector;
	source: CrmLeadSource;
	status: CrmLeadStatus;
}

export class CrmLead implements CrmLead {

	constructor(data?: Partial<CrmLead>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
